import Button from '@mui/material/Button';
import { useNavigate } from 'react-router';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';
import { seedRecommendationUrl } from '/@/views/recommendations/seed-recommendation-route';
import Drawing from '../../drawing';
import styles from './styles.module.css';

function FooterCarbonCalculator(props) {
    const navigate = useNavigate();

    const handleClickRecommendation = async () => {
        return navigate(
            seedRecommendationUrl({
                crop: 'corn',
                fieldId: props.selectedField.id,
                entrySource: 'carbon-calculator',
            })
        );
    };
    return (
        <div className={styles.containerReco}>
            <div className={styles.chalaDiv}>
                <Drawing type='success-corn' style={{ width: 100, backgroundPosition: 'bottom' }} />
                <Title color='dark' size='md' className={styles.title}>
                    {_('¡Tenés pensado sembrar maíz!, si querés podés pedir una recomendación.')}
                </Title>
                <Button variant='contained' size='medium' onClick={handleClickRecommendation}>
                    {_('Pedir una recomendación')}
                </Button>
            </div>
        </div>
    );
}

export default FooterCarbonCalculator;
